require('./loginAsClientView.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const FormGetKey = require('components/myProfile/loginAsClient/formGetKey/formGetKey');
const { formatText, getLanguage } = require('core/i18n').i18n;
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ utilities
const typeDoc = require('utilities/typeDocument');

// @ constants
const { ERROR_INVALID_PASSWORD, ERROR_USER_BLOCKED } = require('constants/contactCenter/errorTypes');
const {
    TRANSLATION_PLATFORM_PRI,
    TRANSLATION_PLATFORM_CC
} = require('constants/translations');

class LoginAsClientView extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { requestGetProfile, requestTranslations } = this.props;
        requestGetProfile();
        requestTranslations( __CONTACT_CENTER__ ? TRANSLATION_PLATFORM_CC : TRANSLATION_PLATFORM_PRI, getLanguage())
    }

    render() {
        const { requestClientPinValidation , immLoginAsClient , immProfileFields } = this.props;
        const legalText = formatText('loginAsClient-legalText');
        const isFetchingSendKey = immLoginAsClient.get('isFetching');
        const documentId = immProfileFields.get('documentoIdentificacion').get('codigodocumpersonacorp');
        const documentType = immProfileFields.get('documentoIdentificacion').get('tipodocumpersonacorp');
        const country =  immProfileFields.get('originCountry');
        const typeDocument = typeDoc.getLabel(documentType.trim(), country);
        const hasBeenFetched = immProfileFields.get('hasBeenFetched')
        const titleHeader = formatText('loginAsClient-title');
        const unrecoverableError = immLoginAsClient.get('error');
        const immPasswordError = immLoginAsClient.get('passwordError');

        let isInvalidPasswordError = false;
        let isPasswordBlockedError = false;

        if (unrecoverableError || immPasswordError.get('errorType') === ERROR_INVALID_PASSWORD) {
            isInvalidPasswordError = true;
        } else if (immPasswordError.get('errorType') === ERROR_USER_BLOCKED) {
            isPasswordBlockedError = true;
        }

        let content;

        if (hasBeenFetched) {
            content = (
                <FormGetKey
                    documentId={documentId}
                    documentType={typeDocument.label}
                    documentTypeCode={documentType}
                    requestClientPinValidation={requestClientPinValidation}
                    isFetching={isFetchingSendKey}
                    isInvalidPasswordError={isInvalidPasswordError}
                    isPasswordBlockedError={isPasswordBlockedError}
                />
            );
        } else {
            content = <LoadingSection />;
        }

        return (
            <div className="loginasclient-view">
                <OKCover size="small" section="pg">
                    <OKHeaderLanding title={titleHeader}/>
                </OKCover>
                <div className="loginasclient-view__body">
                    <p className="loginasclient-view__legaltext">
                        {legalText}
                    </p>
                    {content}
                </div>
            </div>
        );
    }
}

LoginAsClientView.propTypes = {
    immProfileFields: PropTypes.object,
    immLoginAsClient: PropTypes.object,
    immTranslations: PropTypes.object.isRequired,
    requestClientPinValidation: PropTypes.func,
    requestGetProfile : PropTypes.func,
    country: PropTypes.string,
    requestTranslations: PropTypes.func.isRequired
};

module.exports = LoginAsClientView;
